module["exports"] = [
  "Sr.",
  "Sra.",
  "Sta."
];



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/es/name/prefix.js
 ** module id = 609
 ** module chunks = 0
 **/